import { Box, Collapse, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { FilteredData } from "../SearchWorkflowContainer";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export type MainNameLinefeedProps = {
  item: FilteredData;
};

/**
 * 申請書名折りたたみ表示コンポーネント
 * - 申請種別・申請書名・概要をカード内に表示し、ボタンで概要の展開/折りたたみを切り替える
 * - props: item (申請書データ)
 */
const MainNameLinefeed = (props: MainNameLinefeedProps) => {
  const [expanded, setExpanded] = React.useState(true);

  // 概要テキストの展開/折りたたみを切り替える（親へのイベント伝播を防止）
  const toggleExpand = (event: React.MouseEvent) => {
    event.stopPropagation(); // イベントのバブリングを阻止
    setExpanded(!expanded);
  };

  return (
    <>
      <Grid container size={{ xs: 12 }}>
        <Grid size={{ xs: 10 }} textAlign={"center"}>
          <Typography variant="h3" color="#000000" noWrap>
            {props.item.type}
          </Typography>
          <Typography variant="h3" color="#000000" noWrap>
            {props.item.mainName}
          </Typography>
        </Grid>

        <Grid size={{ xs: 2 }} textAlign={"left"}>
          <Box sx={{backgroundColor : 'transparent', '&:hover' : {backgroundColor : '#f0f0f0',},display: 'inline-flex', alignItems: 'center', borderLeft: '1px solid #000000', paddingX : 1, width: '100%', }} onClick={toggleExpand}>
          <IconButton disableRipple sx={{color: 'inherit', '&:hover' : {backgroundColor: 'transparent', color: 'inherit',},}}>
            {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
          </Box>
        </Grid>
      </Grid>
      <Collapse in={expanded}>
        <Box sx={{ marginTop: 1 }}>
          <Typography variant="body1">{props.item.overview}</Typography>
        </Box>
      </Collapse>
    </>
  );
};

export default MainNameLinefeed;
